<ul id="{{ renderMode }}">
  @for (i of Array(count).fill(1); track $index) {
    <li class="skeleton {{ style }}"></li>
  }
</ul>
